import logoTecnnova from "../images/collaborationEcosystem/logo-tecnnova.png"
import logoTecnoparque from "../images/collaborationEcosystem/logo-tecnoparque.png"
import logoUdeA from "../images/collaborationEcosystem/logo-uda.png"
import logoUPB from "../images/collaborationEcosystem/logo-upb.svg"

export const CollaborationEcosystemMessages = {
  company1: {
    imagePath: `${logoUdeA}`,
    title: "Universidad de Antioquia",
    link: "https://www.udea.edu.co/wps/portal/udea/web/inicio/!ut/p/z1/hY67DoJAEEW_xYKWGVhWwW6DxICER2IibmPAIGB4ZUH4fTdqYeFjujv3nMkAhwR4m05VkY5V16a1zEe-PAUxdTTdRj90iYOxFdCIbF3dWBE4_AO4rPHLMJQ-fyCmZesaM9DHnUaRxU4U7EM72nj6C_hxwwNe1F32fJe1GTEL4CK_5CIX6k3IdTmO_bBWUMF5ntWsagv13DUKfhLKbhgheeegbxK80nry2WJxB3VM31o!/dz/d5/L2dBISEvZ0FBIS9nQSEh/",
  },
  company2: {
    imagePath: `${logoUPB}`,
    title: "Universidad Pontificia Bolivariana",
    link: "https://www.upb.edu.co/es/homebanner",
  },
  company3: {
    imagePath: `${logoTecnoparque}`,
    title: "Tecnoparque",
    link: "https://redtecnoparque.com/",
  },
  company4: {
    imagePath: `${logoTecnnova}`,
    title: "Tecnnova",
    link: "https://tecnnova.org/",
  },
}
